import { Button, Row, Select } from 'antd'
import { useState } from 'react'
{ Option } = Select
import { DatabaseOutlined } from '@ant-design/icons'
import GeneralTemplate from './general'
import { NodePicker } from 'Components'

SelectNode = (componentConf) -> GeneralTemplate({
  InputHandler: ({ startPlugin }) ->

    [nodeId, setNodeId] = useState(undefined)

    <div>
      <Row style={{ margin: '40px 0 20px', minWidth: '600px'}}>
        <NodePicker
          query={componentConf.query}
          mode="multiple"
          onSelect={(vals) -> setNodeId(vals[0])}
          style={{ width: '95%' }}
        />
      </Row>
      <Row style={{ margin: '40px 0 20px' }}>
        <Button
          onClick={-> componentConf.handleSelect(nodeId, startPlugin)}
          icon={<DatabaseOutlined />}
        >
          {componentConf.buttonLabel}
        </Button>
      </Row>
    </div>
  ResponseHandler: ({ response }) ->
    componentConf.handleResponse(response)
})

export default SelectNode
